import { CSSProperties, HTMLAttributes } from 'react';

interface ContentLeftSideItemProps {
    children: React.ReactNode
}

export function ContentLeftSideItem({ children }: ContentLeftSideItemProps) {
    return (
        <li>{children}</li>
    );
}

interface ContentLeftSideStickyProps extends HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode,
    ulStyle?: CSSProperties,
}

function ContentLeftSideSticky({ children, ulStyle, ...props }: ContentLeftSideStickyProps) {
    return (
        <div className="content-add__nav-sticky" {...props}>
            <ul className="content-add__nav" style={ulStyle}>
                {children}
            </ul>
        </div>
    );
}

export default ContentLeftSideSticky;
